import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Rect } from '../IconBase/IconBase'

function CheckedRect({
  color = 'icon.greenCheck',
  strokeColor = 'white',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 34 34' {...props}>
      <Rect width='34' height='34' rx='4' fill={color} />
      <Path
        d='M24 12L14.7709 22L10 17.0318'
        stroke={strokeColor}
        fill={fill}
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

CheckedRect.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeColor: PropTypes.string,
}

export default CheckedRect
